export interface IChartLegendItem {
  color: string;
  label: string;
  range?: (value: number) => boolean;
  line?: number;
}

const defaultLegendList: IChartLegendItem[] = [
  {
    color: 'green',
    label: '좋음',
  },
  {
    color: 'orange',
    label: '중간',
  },
  {
    color: 'red',
    label: '나쁨',
  },
];

export const getDefualtLegendList = (colorLineInfo?: { greenMaxLine: number | null; orangeMaxLine: number | null; redMaxLine: number | null }) => {
  const standard = Object.values(colorLineInfo || {}).map((val) => val || 0);
  const currentStandard = standard[0] < standard[2] ? standard : [standard[2], standard[1], standard[0]];
  const currentLegendList = standard[0] < standard[2] ? defaultLegendList : [defaultLegendList[2], defaultLegendList[1], defaultLegendList[0]];
  return [
    {
      ...currentLegendList[0],
      range: (value: number) => value <= currentStandard[0],
    },
    {
      ...currentLegendList[1],
      range: (value: number) => value <= currentStandard[1] && value > currentStandard[0],
    },
    {
      ...currentLegendList[2],
      range: (value: number) => value > currentStandard[1],
    },
  ];
};

export const B_11_LegendList: IChartLegendItem[] = [
  {
    color: '#40A640', // >= 600
    label: '충족',
    range: (value: number) => value >= 600,
  },
  {
    color: '#F24D4D', // < 600
    label: '미충족',
    range: (value: number) => value < 600,
  },
];

export const B_12_LegendList: IChartLegendItem[] = [
  {
    color: '#40A640', // <= 2
    label: '저위험 음주',
    range: (value: number) => value <= 2,
  },
  {
    color: '#FFB800', // <= 5
    label: '주의 필요',
    range: (value: number) => value <= 5 && value > 2,
  },
  {
    color: '#F24D4D', // <= 8
    label: '고위험 음주',
    range: (value: number) => value <= 8 && value > 5,
  },
];

export const B_13_LegendList: IChartLegendItem[] = [
  {
    color: '#40A640', // 1
    label: '비흡연자',
    range: (value: number) => value === 1,
  },
  {
    color: '#FFB800', // 2
    label: '주의 필요',
    range: (value: number) => value === 2,
  },
  {
    color: '#F24D4D', // 3
    label: '위험',
    range: (value: number) => value === 3,
  },
];

export const M_10_LegendList: IChartLegendItem[] = [
  {
    color: '#40A640', // 1
    label: '좋음',
    range: (value: number) => value === 1,
  },
  {
    color: '#FFB800', // 2
    label: '보통',
    range: (value: number) => value === 2,
  },
  {
    color: '#F24D4D', // 3
    label: '나쁨',
    range: (value: number) => value === 3,
  },
];

export const M_11_LegendList: IChartLegendItem[] = [
  {
    color: '#2E8C2E', // <= 4
    label: '정상',
    range: (value: number) => value <= 4,
  },
  {
    color: '#8CD159', // <= 9
    label: '가벼운 우울',
    range: (value: number) => value <= 9 && value > 4,
  },
  {
    color: '#FFC700', // <= 14
    label: '다소 높은 우울',
    range: (value: number) => value <= 14 && value > 9,
  },
  {
    color: '#FF8C33', // <= 19
    label: '높은 우울',
    range: (value: number) => value <= 19 && value > 14,
    line: 1,
  },
  {
    color: '#F24D4D', // <= 27
    label: '매우 높은 우울',
    range: (value: number) => value <= 27 && value > 19,
    line: 1,
  },
];

export const M_12_LegendList: IChartLegendItem[] = [
  {
    color: '#2E8C2E', // <= 4
    label: '불안 낮음',
    range: (value: number) => value <= 4,
  },
  {
    color: '#8CD159', // <= 9
    label: '가벼운 불안',
    range: (value: number) => value <= 9 && value > 4,
  },
  {
    color: '#FF9940', // <= 14
    label: '다소 높은 불안',
    range: (value: number) => value <= 14 && value > 9,
  },
  {
    color: '#F24D4D', // >= 15
    label: '높은 불안',
    range: (value: number) => value >= 15,
  },
];

export const M_13_LegendList: IChartLegendItem[] = [
  {
    color: '#60A5FA', // < 18.5
    label: '저체중',
    range: (value: number) => value < 18.5,
  },
  {
    color: '#22C55E', // <= 22.9
    label: '정상',
    range: (value: number) => value <= 22.9 && value >= 18.5,
  },
  {
    color: '#FACC15', // <= 24.9
    label: '과체중',
    range: (value: number) => value <= 24.9 && value > 22.9,
  },
  {
    color: '#FB923C', // <= 29.9
    label: '1단계 비만',
    range: (value: number) => value <= 29.9 && value > 24.9,
  },
  {
    color: '#EF4444', // <= 34.9
    label: '2단계 비만',
    range: (value: number) => value <= 34.9 && value > 29.9,
    line: 1,
  },
  {
    color: '#991B1B', // >= 35
    label: '3단계 비만',
    range: (value: number) => value >= 35,
    line: 1,
  },
];

export const M_14_LegendList: IChartLegendItem[] = [
  {
    color: '#40A640', // 18~25(새로운 가능성)
    label: '좋음',
    range: (value: number) => value > 17,
  },
  {
    color: '#F24D4D', // 0~17(새로운 가능성)
    label: '나쁨',
    range: (value: number) => value <= 17,
  },
];
export const M_15_LegendList: IChartLegendItem[] = [
  {
    color: '#40A640', // 15~20(내적 역량 강화)
    label: '좋음',
    range: (value: number) => value > 14,
  },
  {
    color: '#F24D4D', // 0~14(내적 역량 강화)
    label: '나쁨',
    range: (value: number) => value <= 14,
  },
];

export const S_11_LegendList: IChartLegendItem[] = [
  {
    color: '#40A640',
    label: '좋음',
    range: (value: number) => value > 66,
  },
  {
    color: '#FFB800',
    label: '중간',
    range: (value: number) => value <= 66 && value > 33,
  },
  {
    color: '#F24D4D',
    label: '나쁨',
    range: (value: number) => value <= 33,
  },
];

export const S_12_LegendList: IChartLegendItem[] = [
  {
    color: '#40A640', // <= 39
    label: '일반',
    range: (value: number) => value === 1,
  },
  {
    color: '#FFB800', // <=43
    label: '잠재적 위험',
    range: (value: number) => value === 2,
  },
  {
    color: '#F24D4D', // >= 44
    label: '고위험',
    range: (value: number) => value === 3,
  },
];

export const C_LegendList: IChartLegendItem[] = [
  {
    color: '#40A640', // <= 100
    label: '높음',
    range: (value: number) => value > 66,
  },
  {
    color: '#FFB800', // <= 66
    label: '보통',
    range: (value: number) => value <= 66 && value > 33,
  },
  {
    color: '#F24D4D', // <= 33
    label: '낮음',
    range: (value: number) => value <= 33,
  },
];

export const youngAdultLegendList: { [key: string]: IChartLegendItem[] } = {
  CHI_B_11: B_11_LegendList, // 신체건강_신체활동
  CHI_B_12: B_12_LegendList, // 신체건강_음주력
  CHI_B_13: B_13_LegendList, // 신체건강_흡연
  CHI_M_10: M_10_LegendList, // 정신건강_스트레스
  CHI_M_11: M_11_LegendList, // 정신건강_우울감
  CHI_M_12: M_12_LegendList, // 정신건강_불안감
  CHI_M_13: M_13_LegendList, // 정신건강_신체이미지
  CHI_M_14: M_14_LegendList, // 정신건강_목표지향_새로운가능성
  CHI_M_15: M_15_LegendList, // 정신건강_목표지향_내적역량강화
  CHI_S_11: S_11_LegendList, // 사회적건강_사회적지지
  CHI_S_12: S_12_LegendList, // 사회적건강_스마트폰사용경험
  CHI_C_11: C_LegendList, // 사회적건강_건강관련삶의질_신체기능
  CHI_C_12: C_LegendList, // 사회적건강_건강관련삶의질_신체적역할제한
  CHI_C_13: C_LegendList, // 사회적건강_건강관련삶의질_감정적역할제한
  CHI_C_14: C_LegendList, // 사회적건강_건강관련삶의질_사회적기능
  CHI_C_15: C_LegendList, // 사회적건강_건강관련삶의질_신체통증
  CHI_C_16: C_LegendList, // 사회적건강_건강관련삶의질_전반적건강
  CHI_C_17: C_LegendList, // 사회적건강_건강관련삶의질_활력
  CHI_C_18: C_LegendList, // 사회적건강_건강관련삶의질_정신건강
  CHI_C_19: C_LegendList, // 사회적건강_건강관련삶의질_건강변화
};

export const youngAdultKeyList = Object.keys(youngAdultLegendList);
